import { render, staticRenderFns } from "./CardCajaMunicipal.vue?vue&type=template&id=ff6efcfa&"
import script from "./CardCajaMunicipal.vue?vue&type=script&lang=js&"
export * from "./CardCajaMunicipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports